<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li>
                                <a v-on:click="goSchools()">Schools</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">{{ schoolName }} (Request for plan change)</a>
                            </li>
                        </ul>
                    </nav>
                    <div class="columns">
                        <div class="column is-12">
                            <div class="card events-card">
                                <div class="card-content">                                    
                                    <div class="content">
                                        <div class="field">
                                            Current plan: {{ displayPlan(changePlanRequest.currentPlan) }}<br/>
                                        </div>
                                        <div class="field">
                                            Request to change: <b>{{ displayPlan(changePlanRequest.requestedPlan) }}</b><br/>
                                        </div>
                                        <div class="field">
                                            Requested On: <b>{{ moment(changePlanRequest.addedOn).format('LLLL') }}</b><br/>
                                        </div>
                                        <div class="field">
                                            Requested By: <b>{{ changePlanRequest.requestedBy.firstName }} ({{ changePlanRequest.requestedBy.email }} {{ changePlanRequest.requestedBy.contactNo }})</b><br/>
                                        </div>
                                        <div class="field">
                                            <div class="control">
                                                <b-select id="plan" name="plan" v-model="requestStatus">
                                                    <option value="0">PLEASE CHOOSE</option>
                                                    <option value="1">ACCEPT</option>
                                                    <option value="2">REJECT</option>
                                                </b-select>
                                            </div>
                                        </div>
                                        <footer class="card-footer">
                                            <a v-on:click="updateRequest()" class="card-footer-item">Submit</a>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Datepicker from "vuejs-datepicker";
import { ToastProgrammatic as Toast } from 'buefy'
const helper = require("../../../config/helper")

export default {
    name: "SuperSchoolViewChangePlanRequest",
    components: {
        TopMenu,
        Loading
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            requestID: "",
            schoolName: "",
            isLoading1: false,
            changePlanRequest: [],
            requestStatus: 0
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");        

        this.requestID = this.$store.getters.getSuperViewPlanChangeRequestID;
        if (this.requestID.trim.length < 1){
            this.requestID = localStorage.getItem('SUPER_VIEW_PLAN_CHANGE_REQUEST_ID')
        }
        console.log("99 this.requestID: " + this.requestID)

        this.schoolName = this.$store.getters.getSuperViewPlanChangeRequestSchoolName;
        if (this.schoolName.trim.length < 1){
            this.schoolName = localStorage.getItem('SUPER_VIEW_PLAN_CHANGE_REQUEST_SCHOOL_NAME')
        }
        console.log("214 this.schoolName: " + this.schoolName)

        this.getChangePlanRequestInfo();
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {       
        getChangePlanRequestInfo() {
            let self = this;
            self.isLoading1 = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/school/changePlan/view", {
                    superEmail: localStorage.getItem("superEmail"),
                    requestID: self.requestID
                })
                .then(response => {
                    console.log("125 response.data")
                    console.log(response.data)
                    if (response.data.success == true) {
                        self.changePlanRequest = response.data.content
                    } else {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                })
                .catch(e => {
                    console.log(e.response);
                    if (e.response.status == 400) {
                        Toast.open({
                            message: e.response.data.msg,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    } else {
                        Toast.open({
                            message:
                                "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                            type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        });
                    }
                    self.isLoading1 = false;
                });
        },
        updateRequest(){
            let self = this

            if (self.requestStatus == 0){                
                Toast.open({
                    message: "Please select whether you want to ACCEPT or REJECT the request.",
                    type: "is-warning", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                });
            }else{
                var displayResult = "ACCEPT"
                if (self.requestStatus == 1){
                    displayResult = "ACCEPT"
                }else{
                    displayResult = "REJECT"
                }
                
                this.$swal({
                    title: "Are you sure?",
                    text: displayResult + " the change plan request for " + self.schoolName + "?",
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: true
                }).then((result) => {
                    if (result.value){
                        self.isLoading2 = true;
                        axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                        axios.defaults.responseType = "json";
                        axios.post(process.env.MY_URL + "/super/school/changePlan/update", {
                                superEmail: localStorage.getItem("superEmail"),
                                requestID: self.requestID,
                                status: self.requestStatus
                            })
                            .then(response => {
                                if (response.data.success == true) {
                                    Toast.open({
                                        message: response.data.msg,
                                        type: 'is-success',
                                        duration: 3000
                                    })
                                } else {
                                    Toast.open({
                                        message: e.response.data.msg,
                                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    });
                                }
                                self.isLoading2 = false;
                            })
                            .catch(e => {
                                console.log(e.response);
                                if (e.response.status == 400) {
                                    Toast.open({
                                        message: e.response.data.msg,
                                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    });
                                } else {
                                    Toast.open({
                                        message: "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 5000
                                    });
                                }
                                self.isLoading2 = false;
                            });
                    }
                })

            }
        },
        displayPlan(plan){
            return helper.getPlanName(plan)
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSchools() {
            this.$router.push({
                name: "SuperSchools"
            });
        },
    }
};
</script>

<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/SchoolViewChangePlanRequest.vue